import { ArticleTimelineEvent } from '../../types';

interface ArticleTimelineProps {
  events: ArticleTimelineEvent[];
}

/** Linha do tempo reutilizável com eventos anteriores relacionados ao tema. */
export const ArticleTimeline: React.FC<ArticleTimelineProps> = ({ events }) => {
  if (!events || events.length === 0) return null;

  return (
    <section className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Linha do tempo</h2>
      <ol className="relative border-l-2 border-blue-100 ml-2 space-y-5">
        {events.map((event) => (
          <li key={event.id} className="ml-5">
            <span
              className="absolute -left-[7px] mt-1.5 w-3 h-3 rounded-full bg-blue-500 border-2 border-white"
              aria-hidden
            />
            <p className="text-xs font-bold text-blue-600 uppercase tracking-wide mb-0.5">{event.date}</p>
            <p className="font-semibold text-gray-900 text-sm">{event.title}</p>
            {event.description && (
              <p className="text-gray-600 text-sm leading-relaxed mt-0.5">{event.description}</p>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
};
